export default [
  {
    title: 'Acquisition',
    icon: 'ServerIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'All Channels',
        route: 'acquisition-all-channels',
      },
      {
        title: 'Websites',
        route: 'acquisition-websites',
      },
      {
        title: 'Search Engines',
        route: 'acquisition-search-engines',
      },
      {
        title: 'Social Networks',
        route: 'acquisition-social-networks',
      },
      {
        title: 'Campaigns',
        route: 'acquisition-campaigns',
      }
    ],
  },
]
